/* KEY STUDIO — refonte v3 : en-tête, menu, apparitions, visionneuse, formulaire de contact.
   Aucun lien avec le simulateur : il garde son propre script, inchangé. */
(function () {
  "use strict";
  var doc = document.documentElement;
  var reduit = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* En-tête v4 : barre sombre fixe, sans état « sur la photo ». */
  var entete = null;

  /* Menu sur téléphone et tablette. */
  var burger = document.querySelector(".k-burger");
  var menu = document.getElementById("k-menu");
  if (burger && menu) {
    var ouvrir = function (oui) {
      menu.hidden = !oui;
      document.body.classList.toggle("k-menu-ouvert", oui);
      burger.setAttribute("aria-expanded", oui ? "true" : "false");
      burger.setAttribute("aria-label", oui ? "Fermer le menu" : "Ouvrir le menu");
      if (entete && entete.hasAttribute("data-sur-photo")) entete.classList.toggle("k-sur-photo", !oui && window.scrollY < 40);
      if (oui) { var premier = menu.querySelector("a"); if (premier) premier.focus({ preventScroll: true }); }
    };
    burger.addEventListener("click", function () { ouvrir(menu.hidden); });
    menu.addEventListener("click", function (e) { if (e.target.closest("a")) ouvrir(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !menu.hidden) { ouvrir(false); burger.focus(); }
    });
    window.matchMedia("(min-width: 1100px)").addEventListener("change", function (m) { if (m.matches) ouvrir(false); });
  }

  /* Apparition discrète des blocs marqués data-rv. */
  var aReveler = document.querySelectorAll("[data-rv]");
  if (aReveler.length && "IntersectionObserver" in window && !reduit) {
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("k-vu"); obs.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    aReveler.forEach(function (el) { obs.observe(el); });
    /* Filet de sécurité : rien ne doit rester invisible. */
    setTimeout(function () { aReveler.forEach(function (el) { el.classList.add("k-vu"); }); }, 4000);
  } else {
    aReveler.forEach(function (el) { el.classList.add("k-vu"); });
  }

  /* Visionneuse : tout bouton [data-visio] d'un même groupe [data-galerie]. */
  var groupes = document.querySelectorAll("[data-galerie]");
  if (groupes.length) {
    var visio = document.createElement("div");
    visio.className = "k-visio";
    visio.hidden = true;
    visio.setAttribute("role", "dialog");
    visio.setAttribute("aria-modal", "true");
    visio.setAttribute("aria-label", "Photo en grand");
    visio.innerHTML =
      '<div class="k-visio-haut"><span class="k-visio-legende" id="k-visio-compteur"></span><button type="button" data-fermer>Fermer</button></div>' +
      '<div class="k-visio-img"><img alt="" id="k-visio-photo"></div>' +
      '<div class="k-visio-bas"><button type="button" data-prec aria-label="Photo précédente">←</button><span class="k-visio-legende" id="k-visio-legende"></span><button type="button" data-suiv aria-label="Photo suivante">→</button></div>';
    document.body.appendChild(visio);
    var img = visio.querySelector("#k-visio-photo");
    var leg = visio.querySelector("#k-visio-legende");
    var cpt = visio.querySelector("#k-visio-compteur");
    var liste = [], index = 0, retour = null;
    var montrer = function (i) {
      index = (i + liste.length) % liste.length;
      var b = liste[index];
      img.src = b.getAttribute("data-visio");
      img.alt = b.getAttribute("data-alt") || "";
      leg.textContent = b.getAttribute("data-legende") || "";
      cpt.textContent = String(index + 1).padStart(2, "0") + " / " + String(liste.length).padStart(2, "0");
    };
    var fermer = function () {
      visio.hidden = true;
      document.body.style.overflow = "";
      if (retour) retour.focus({ preventScroll: true });
    };
    groupes.forEach(function (g) {
      g.addEventListener("click", function (e) {
        var b = e.target.closest("[data-visio]");
        if (!b) return;
        liste = Array.prototype.slice.call(g.querySelectorAll("[data-visio]"));
        retour = b;
        montrer(liste.indexOf(b));
        visio.hidden = false;
        document.body.style.overflow = "hidden";
        visio.querySelector("[data-fermer]").focus({ preventScroll: true });
      });
    });
    visio.querySelector("[data-fermer]").addEventListener("click", fermer);
    visio.querySelector("[data-prec]").addEventListener("click", function () { montrer(index - 1); });
    visio.querySelector("[data-suiv]").addEventListener("click", function () { montrer(index + 1); });
    visio.addEventListener("click", function (e) { if (e.target === visio || e.target.classList.contains("k-visio-img")) fermer(); });
    document.addEventListener("keydown", function (e) {
      if (visio.hidden) return;
      if (e.key === "Escape") fermer();
      if (e.key === "ArrowLeft") montrer(index - 1);
      if (e.key === "ArrowRight") montrer(index + 1);
    });
    var x0 = null;
    visio.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    visio.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) montrer(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* Formulaire de contact : objet choisi selon l'ancre, remerciement au retour de Shopify. */
  var form = document.getElementById("contact_form");
  if (form) {
    var objet = form.querySelector("#k-objet");
    if (objet && location.hash === "#signature") objet.value = "Prestation Signature (devis)";
    if (/[?&]contact_posted=true/.test(location.search)) {
      form.hidden = true;
      var merci = document.getElementById("k-merci");
      if (merci) { merci.hidden = false; setTimeout(function () { merci.scrollIntoView({ block: "center" }); }, 300); }
    }
  }

  doc.classList.add("k-pret");
})();
